import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import SvgClose from 'components/svgs/close';
import VeggieBurgerButton from '../veggieBurgerButton/veggieBurgerButton';
import { buttonClose, menuContainer, menuLinksContainer, menuUtilityContainer, } from './mobileMenuStyles';
// ----- Component ----- //
function MobileMenu({ onClose, closeButtonAt, utility, links, }) {
    return (_jsxs("div", { css: menuContainer, style: closeButtonAt && {
            width: closeButtonAt.x,
        }, children: [_jsxs("div", { css: menuLinksContainer, children: [links, utility && _jsx("div", { css: menuUtilityContainer, children: utility })] }), _jsx(VeggieBurgerButton, { style: closeButtonAt && {
                    top: closeButtonAt.y,
                }, "aria-label": "close", onClick: onClose, cssOverride: buttonClose, children: _jsx(SvgClose, {}) })] }));
}
MobileMenu.defaultProps = {
    closeButtonAt: null,
    utility: null,
};
export default MobileMenu;
